import {createConfigurationValuesService} from '@services/factories';
import {IConfigurationValuesService} from '@services/ConfigurationValuesService';

export const useConfigs = (): IConfigurationValuesService => {
  return createConfigurationValuesService();
}



// WEBPACK FOOTER //
// ./src/hooks/useConfigs.ts